<template>
  <div id="app">
    <head-top></head-top>
    <router-view />
    <bottom></bottom>
  </div>
</template>

<script>
import HeadTop from "@/components/head/head.vue";
import Bottom from "@/components/bottom/bottom.vue";
export default {
  name: "app",
  components: {
      'head-top': HeadTop,
      'bottom': Bottom,
    },
  created() {
    var userAgent = navigator.userAgent;
  // 判断是否为小于IE11的浏览器
  var isLessIE11 = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  if (isLessIE11) {
    alert('当前浏览器版本过低，为了更好的访问体验，请及时升级浏览器或更换其他浏览器访问')
  } 
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background:rgba(255,255,255,1);
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
h3 {
  margin-top: 0.416667rem;
  font-size: .208333rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(9, 22, 48, 1);
  line-height: .208333rem;
}
.short_stub {
  display: flex;
  align-items: center;
  margin-bottom: 0.3125rem;
}
.short_stub div:nth-child(1) {
  width: 0.208333rem;
  height: 0.026042rem;
  background: rgba(47, 110, 240, 1);
  border-radius: 0.020833rem;
}
.short_stub div:nth-child(2) {
  width: 0.041667rem;
  height: 0.026042rem;
  background: rgba(47, 110, 240, 1);
  border-radius: 0.020833rem;
  margin-left: 0.026042rem;
}
</style>
